export enum REQUEST_ORIGINS {
  QUICK_ACTION_SIDEBAR = 'QUICK_ACTION_SIDEBAR',
  REQUESTS = 'REQUESTS',
  CONTACT_PANEL_SHORTCUT = 'CONTACT_PANEL_SHORTCUT',
  CONTACT_PANEL_PAYMENTS_TAB = 'CONTACT_PANEL_PAYMENTS_TAB',
  HOME_PAGE_QUICK_ACTION = 'HOME_PAGE_QUICK_ACTION',
  COLLECTIONS_MANUAL = 'COLLECTIONS_MANUAL',
  SCHEDULE_CARD = 'SCHEDULE_CARD',
  PATIENTS_LIST = 'PATIENTS_LIST',
}
